// extracted by mini-css-extract-plugin
module.exports = {"label":"b429494557--label--ClyF3","logo":"b429494557--logo--BPX9_","img":"b429494557--img--NzfhZ"};